import { isDefined } from 'utils/tsHelpers';
import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';

export const useHandleMovableInkInsert = () => {
  const { selectedImage, selectedImageAnchor, htmlEditorRef } = useWYSIWYGContext();

  return (imgAttrs: Record<string, string>, linkAttrs: Record<string, string>) => {
    const hasSelectedImage = isDefined(selectedImage);
    const hasSelectedImageAnchor = isDefined(selectedImageAnchor);
    const linkHasHref = linkAttrs.href;

    if (
      hasSelectedImage &&
      ((hasSelectedImageAnchor && linkHasHref) || (!hasSelectedImageAnchor && !linkHasHref))
    ) {
      // update the existing image (and link)
      htmlEditorRef?.current?.dom.setAttribs(selectedImage, imgAttrs);
      if (isDefined(selectedImageAnchor)) {
        htmlEditorRef?.current?.dom.setAttribs(selectedImageAnchor, linkAttrs);
      }
      // important: if you don't call focus(), the change will appear in the UI, but will not be
      // reflected in the current value until another action is taken (like adding text)
      htmlEditorRef?.current?.focus();
    } else if (hasSelectedImage && hasSelectedImageAnchor && !linkHasHref) {
      // replace the previous image anchor with the image
      htmlEditorRef?.current?.focus();
      const imgNode = htmlEditorRef?.current?.dom.create('img', {
        ...imgAttrs,
        'data-mce-id': '__mcenew',
      });
      htmlEditorRef?.current?.dom.replace(imgNode, selectedImageAnchor);
      // select the inserted image (or link with child image)
      const insertedElm = htmlEditorRef?.current?.dom.select('[data-mce-id="__mcenew"]')[0];
      // correct the selection range
      htmlEditorRef?.current?.selection.select(insertedElm);
      // clear the temporary selector
      htmlEditorRef?.current?.dom.setAttrib(insertedElm, 'data-mce-id', null);
    } else {
      // insert new content at the current selection/caret location
      htmlEditorRef?.current?.focus();
      if (linkHasHref) {
        const imgNode = htmlEditorRef?.current?.dom.create('img', {
          ...imgAttrs,
          'data-mce-id': '__mcenew',
        });
        const linkNode = htmlEditorRef?.current?.dom.create('a', linkAttrs);
        linkNode.appendChild(imgNode);
        htmlEditorRef?.current?.selection.setNode(linkNode);
      } else {
        htmlEditorRef?.current?.selection.setNode(
          htmlEditorRef?.current?.dom.create('img', { ...imgAttrs, 'data-mce-id': '__mcenew' }),
        );
      }
      // select the inserted image (or link with child image)
      const insertedElm = htmlEditorRef?.current?.dom.select('[data-mce-id="__mcenew"]')[0];
      // correct the selection range
      htmlEditorRef?.current?.selection.select(insertedElm);
      // clear the temporary selector
      htmlEditorRef?.current?.dom.setAttrib(insertedElm, 'data-mce-id', null);
    }
  };
};
